<!-- Path: libs/components/modal/src/lib/ui-modal/ui-modal.component.html -->
@if (open()) {
  <div
    class="ui-modal__backdrop"
    role="button"
    tabindex="0"
    aria-label="Fechar modal"
    (click)="onBackdropClick()"
    (keydown.enter)="onBackdropKeydown($event)"
    (keydown.space)="onBackdropKeydown($event)"
  >
 <section
      class="ui-modal"
      [attr.data-size]="size()"
      [attr.data-tone]="tone()"
      [attr.data-has-floating-image]="floatingImageSrc() || floatingSlot() ? 'true' : null"
      role="dialog"
      aria-modal="true"
      [attr.aria-label]="title()"
     (click)="$event.stopPropagation()"
  (keydown)="$event.stopPropagation()"
    >
@if (floatingSlot()) {
  <div class="ui-modal__floating-image-shell ui-modal__floating-image-shell--content">
    <ng-content select="[uiModalFloating]"></ng-content>
  </div>
} @else if (floatingImageSrc()) {
  <div
    class="ui-modal__floating-image-shell"
    [attr.aria-hidden]="floatingImageAlt() ? null : 'true'"
  >
    <img
      class="ui-modal__floating-image"
      [src]="floatingImageSrc()"
      [alt]="floatingImageAlt()"
      width="168"
      height="168"
      loading="lazy"
      decoding="async"
    />
  </div>
}

      <header class="ui-modal__header">
        <div class="ui-modal__header-content">
          <h2 class="ui-modal__title">
            {{ title() }}
          </h2>

          @if (description()) {
            <p class="ui-modal__description">
              {{ description() }}
            </p>
          }
        </div>

        @if (showCloseButton()) {
          <button
            type="button"
            class="ui-modal__icon-button"
            aria-label="Fechar modal"
            (click)="onCloseButtonClick()"
          >
            ×
          </button>
        }
      </header>

      <div class="ui-modal__body">
        <ng-content></ng-content>
      </div>
      @if (showFooter()) {
        <footer class="ui-modal__footer">
          <button
            type="button"
            class="ui-modal__button ui-modal__button--ghost"
            (click)="onCancel()"
          >
            {{ cancelLabel() }}
          </button>

          <button
            type="button"
            class="ui-modal__button ui-modal__button--primary"
            [disabled]="confirmDisabled()"
            (click)="onConfirm()"
          >
            {{ confirmLabel() }}
          </button>
        </footer>
      }
    </section>
  </div>
}